import React from "react";
import { StyleSheet, View, Pressable } from "react-native";
import CustomText from "../CustomText/CustomText";

const TabNavigator = ({
  tabData,
  activeTab,
  onTabPress,
  activeTabColor,
  isFullWidth = false,
  containerStyle = {},
  rightButtonComponent = undefined,
  useTranslationText = true,
}) => {
  return (
    <View style={[styles.navBar, containerStyle]} accessibilityRole="tablist">
      {tabData.map((tab) => (
        <Pressable
          role="tab"
          accessibilityLabel={tab.title}
          key={tab.key}
          style={[
            activeTab === tab.key ? [styles.activeTab, { borderBottomColor: activeTabColor }] : styles.tab,
            isFullWidth ? styles.fullWidthTab : {},
          ]}
          onPress={() => onTabPress(tab.key)}>
          <CustomText
            bold={activeTab === tab.key}
            size="s"
            style={{ color: "#646877" }}
            text={tab.title}
            useTranslationText={useTranslationText}
          />
        </Pressable>
      ))}
      {rightButtonComponent ? rightButtonComponent : null}
    </View>
  );
};

const styles = StyleSheet.create({
  navBar: {
    flexDirection: "row",
    justifyContent: "flex-start",
    borderBottomWidth: 1,
    borderBottomColor: "#D3D3D3",
    alignItems: "center",
  },
  tab: {
    padding: 15,
  },
  activeTab: {
    padding: 15,
    borderBottomWidth: 2,
  },
  fullWidthTab: {
    flexBasis: "33.33%",
    alignItems: "center",
  },
});

export default TabNavigator;
